import { render, staticRenderFns } from "./SuccessPlaceOrders.vue?vue&type=template&id=0bb91c48"
import script from "./SuccessPlaceOrders.vue?vue&type=script&lang=js"
export * from "./SuccessPlaceOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports